import { Typography } from "antd";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import { Five9FormItemKeys } from "../../../../Components/JourneyActionsPanel/NodeEditorPanel/Components/_DemoFormItems/constants";
import { useJourneyBlockData } from "../../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import styles from "./Five9Block.module.scss";

const BLOCK_TITLE = "Integrations";
const NODE_TITLE = "Create Five9 Call";
const NODE_PROMPT = "Select Call";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.DEMO_Five9).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.DEMO_Five9);

export function Five9Block({ data, variant }: SharedBlockProps): JSX.Element {
    const { [Five9FormItemKeys.five9Name]: campaignName, [Five9FormItemKeys.five9ID]: campaignId } = data || {};

    const isNodeConfigured = !!campaignName && !!campaignId;

    const preferedNodeName = `${campaignName} (ID#${campaignId})`;

    const { fallBackTitle, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    return (
        <BlockContainer iconClassName={styles.Five9Brand} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text>{nodeName}</Typography.Text>
            </BlockContent>
        </BlockContainer>
    );
}
